export default {   
    // Icon
    'home': {
        component: import('@/components/integrations/protokol/media/Home'),
        permissions: ['use']
    },

    // Choose media or documents
    'page': {
        component: import('@/components/integrations/protokol/media/Menu'),
        permissions: ['use']
    },

    'menu': {
        component: import('@/components/integrations/protokol/media/Home'),
        permissions: ['use']
    },

    // media
    'media': {
        component: import('@/components/integrations/protokol/media/Index'),
        permissions: ['use']
    },
    
    //documents
    'documents': {
        component: import('@/components/integrations/protokol/media/Documents'),
        permissions: ['use']
    },

    'editor': {
        component: import('@/components/integrations/protokol/media/DocumentEditor'),
        permissions: ['use']
    },

    'ocr-models': {
        component: import('@/components/integrations/protokol/media/OCRModels'),
        permissions: ['use']
    },

    'ocr-editor': {
        component: import('@/components/integrations/protokol/media/OCRModelEditor'),
        permissions: ['use']
    },

    'ocr-extract': {
        component: import('@/components/integrations/protokol/media/OCRExtract'),
        permissions: ['use']
    },
}
